import { getEditLocation } from "../../../core/util/functions";

export const employeeLocation = "/listing/brokers";
export const getEmployeeEditLocation = (id?: string) => getEditLocation(employeeLocation, undefined, id);

export const editRouter = getEmployeeEditLocation(":employeeId?");
